import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    marginBottom: theme.spacing(4),
    [theme.breakpoints.up('mobile')]: {
      width: 392,
      minWidth: 392,
      border: [1, 'solid', theme.palette.colors.divider],
      padding: theme.spacing(4),
      marginBottom: 'unset',
    },
  },
  divider: {
    height: 24,
    borderLeft: [1, 'dotted', theme.palette.colors.teal],
    margin: [theme.spacing(2), theme.spacing(2)],
  },
  discription: {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(4),
  },
  button: {
    width: '100%',
    [theme.breakpoints.up('mobile')]: {
      width: 'unset',
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/ReferralRealEstateAgent/components/Guide/useStyles.js